export const GUIDE = {
  en: {
    title: "Quick Setup — 2 minutes",
    sub: "Do this once, then just talk to your Munshi!",
    steps: [
      "Open Settings (gear icon in chat header) and enter your shop name",
      "Have a logo? Upload it — it will appear on your PDF bills",
      "Set your bill prefix & starting number (e.g. INV-101)",
      "Have GST? Turn GST ON and add your GSTIN & default rate",
      "Link your WhatsApp number — the bot works on WhatsApp too",
      "Want stock tracking? Open Dukaan Register → Stock tab, add items by voice/typing/CSV. When new stock arrives, just say \"50 kilo chawal aaya\"",
      "Make a sale by voice — say \"Ramesh ko 2 kilo atta ka bill banao\". Bill ready — share on WhatsApp!",
    ],
  },
  hi: {
    title: "क्विक सेटअप — 2 मिनट",
    sub: "एक बार यह करें, फिर बस अपने मुंशी से बात करें!",
    steps: [
      "Settings खोलें (चैट में ⚙ आइकन) और दुकान का नाम लिखें",
      "लोगो है? अपलोड करें — PDF बिल पर दिखेगा",
      "बिल prefix और शुरुआती नंबर सेट करें (जैसे INV-101)",
      "GST है? GST चालू करें, GSTIN और डिफ़ॉल्ट रेट डालें",
      "WhatsApp नंबर लिंक करें — बॉट WhatsApp पर भी चलेगा",
      "स्टॉक रखना है? दुकान रजिस्टर → Stock टैब में आइटम जोड़ें (बोलकर/टाइप/CSV)। नया माल आए तो बोलें \"50 किलो चावल आया\"",
      "बोलकर बिक्री करें — \"रमेश को 2 किलो आटा का बिल बनाओ\"। बिल तैयार — WhatsApp पर भेजें!",
    ],
  },
  mr: {
    title: "क्विक सेटअप — 2 मिनिटे",
    sub: "एकदाच करा, मग फक्त मुंशीशी बोला!",
    steps: [
      "Settings उघडा (चॅटमधील ⚙ आयकॉन) आणि दुकानाचे नाव लिहा",
      "लोगो आहे? अपलोड करा — PDF बिलावर दिसेल",
      "बिल prefix आणि सुरुवातीचा नंबर सेट करा (उदा. INV-101)",
      "GST आहे? GST चालू करा, GSTIN व डीफॉल्ट रेट टाका",
      "WhatsApp नंबर लिंक करा — बॉट WhatsApp वरही चालेल",
      "स्टॉक ठेवायचा? दुकान रजिस्टर → Stock टॅबमध्ये वस्तू जोडा (बोलून/टाइप/CSV)। नवीन माल आला की म्हणा \"50 किलो तांदूळ आला\"",
      "बोलून विक्री करा — \"रमेशला 2 किलो पीठाचे बिल बनवा\"। बिल तयार — WhatsApp वर पाठवा!",
    ],
  },
  gu: {
    title: "ક્વિક સેટઅપ — 2 મિનિટ",
    sub: "એકવાર કરો, પછી બસ મુનશી સાથે વાત કરો!",
    steps: [
      "Settings ખોલો (ચેટમાં ⚙ આઇકન) અને દુકાનનું નામ લખો",
      "લોગો છે? અપલોડ કરો — PDF બિલ પર દેખાશે",
      "બિલ prefix અને શરૂઆતનો નંબર સેટ કરો (જેમ કે INV-101)",
      "GST છે? GST ચાલુ કરો, GSTIN અને ડિફોલ્ટ રેટ નાખો",
      "WhatsApp નંબર લિંક કરો — બોટ WhatsApp પર પણ ચાલશે",
      "સ્ટોક રાખવો છે? દુકાન રજિસ્ટર → Stock ટેબમાં વસ્તુઓ ઉમેરો (બોલીને/ટાઈપ/CSV)। નવો માલ આવે તો કહો \"50 કિલો ચોખા આવ્યા\"",
      "બોલીને વેચાણ કરો — \"રમેશને 2 કિલો લોટનું બિલ બનાવો\"। બિલ તૈયાર — WhatsApp પર મોકલો!",
    ],
  },
  ta: {
    title: "விரைவு அமைப்பு — 2 நிமிடம்",
    sub: "ஒருமுறை செய்யுங்கள், பிறகு முன்ஷியிடம் பேசுங்கள்!",
    steps: [
      "Settings திறக்கவும் (சாட்டில் ⚙ ஐகான்) — கடை பெயரை உள்ளிடவும்",
      "லோகோ உள்ளதா? பதிவேற்றவும் — PDF பில்லில் தெரியும்",
      "பில் prefix மற்றும் தொடக்க எண்ணை அமைக்கவும் (எ.கா. INV-101)",
      "GST உள்ளதா? GST ஆன் செய்து GSTIN மற்றும் இயல்பு விகிதம் சேர்க்கவும்",
      "WhatsApp எண்ணை இணைக்கவும் — பாட் WhatsApp-லும் வேலை செய்யும்",
      "ஸ்டாக் வேண்டுமா? Dukaan Register → Stock டேபில் பொருட்களைச் சேர்க்கவும் (பேசி/டைப்/CSV)। புதிய சரக்கு வந்தால் \"50 கிலோ அரிசி வந்தது\" என்று சொல்லுங்கள்",
      "குரலால் விற்பனை — \"ரமேஷுக்கு 2 கிலோ மாவு பில் போடு\" என்று சொல்லுங்கள். பில் ரெடி — WhatsApp-ல் அனுப்புங்கள்!",
    ],
  },
  te: {
    title: "క్విక్ సెటప్ — 2 నిమిషాలు",
    sub: "ఒకసారి చేయండి, తర్వాత మున్షీతో మాట్లాడండి!",
    steps: [
      "Settings తెరవండి (చాట్‌లో ⚙ ఐకాన్) — దుకాణం పేరు రాయండి",
      "లోగో ఉందా? అప్‌లోడ్ చేయండి — PDF బిల్లుపై కనిపిస్తుంది",
      "బిల్ prefix మరియు ప్రారంభ నంబర్ సెట్ చేయండి (ఉదా. INV-101)",
      "GST ఉందా? GST ఆన్ చేసి GSTIN, డిఫాల్ట్ రేటు జోడించండి",
      "WhatsApp నంబర్ లింక్ చేయండి — బాట్ WhatsApp‌లో కూడా పనిచేస్తుంది",
      "స్టాక్ ఉంచాలా? Dukaan Register → Stock ట్యాబ్‌లో వస్తువులు జోడించండి (మాట్లాడి/టైప్/CSV)। కొత్త సరుకు వస్తే \"50 కిలోల బియ్యం వచ్చాయి\" అని చెప్పండి",
      "వాయిస్‌తో అమ్మకం — \"రమేష్‌కి 2 కిలోల పిండి బిల్లు వేయి\" అనండి. బిల్ రెడీ — WhatsApp‌లో పంపండి!",
    ],
  },
  kn: {
    title: "ಕ್ವಿಕ್ ಸೆಟಪ್ — 2 ನಿಮಿಷ",
    sub: "ಒಮ್ಮೆ ಮಾಡಿ, ನಂತರ ಮುನ್ಷಿ ಜೊತೆ ಮಾತಾಡಿ!",
    steps: [
      "Settings ತೆರೆಯಿರಿ (ಚಾಟ್‌ನಲ್ಲಿ ⚙ ಐಕಾನ್) — ಅಂಗಡಿ ಹೆಸರು ಬರೆಯಿರಿ",
      "ಲೋಗೋ ಇದೆಯೇ? ಅಪ್‌ಲೋಡ್ ಮಾಡಿ — PDF ಬಿಲ್‌ನಲ್ಲಿ ಕಾಣುತ್ತದೆ",
      "ಬಿಲ್ prefix ಮತ್ತು ಆರಂಭಿಕ ಸಂಖ್ಯೆ ಹೊಂದಿಸಿ (ಉದಾ. INV-101)",
      "GST ಇದೆಯೇ? GST ಆನ್ ಮಾಡಿ, GSTIN ಮತ್ತು ಡೀಫಾಲ್ಟ್ ದರ ಸೇರಿಸಿ",
      "WhatsApp ನಂಬರ್ ಲಿಂಕ್ ಮಾಡಿ — ಬಾಟ್ WhatsApp‌ನಲ್ಲೂ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
      "ಸ್ಟಾಕ್ ಬೇಕೇ? Dukaan Register → Stock ಟ್ಯಾಬ್‌ನಲ್ಲಿ ವಸ್ತುಗಳನ್ನು ಸೇರಿಸಿ (ಮಾತಾಡಿ/ಟೈಪ್/CSV)। ಹೊಸ ಸರಕು ಬಂದರೆ \"50 ಕಿಲೋ ಅಕ್ಕಿ ಬಂತು\" ಎಂದು ಹೇಳಿ",
      "ಧ್ವನಿಯಿಂದ ಮಾರಾಟ — \"ರಮೇಶ್‌ಗೆ 2 ಕಿಲೋ ಹಿಟ್ಟಿನ ಬಿಲ್ ಮಾಡು\" ಎನ್ನಿ. ಬಿಲ್ ರೆಡಿ — WhatsApp‌ನಲ್ಲಿ ಕಳುಹಿಸಿ!",
    ],
  },
  bn: {
    title: "কুইক সেটআপ — ২ মিনিট",
    sub: "একবার করুন, তারপর শুধু মুনশির সাথে কথা বলুন!",
    steps: [
      "Settings খুলুন (চ্যাটে ⚙ আইকন) — দোকানের নাম লিখুন",
      "লোগো আছে? আপলোড করুন — PDF বিলে দেখা যাবে",
      "বিল prefix ও শুরুর নম্বর সেট করুন (যেমন INV-101)",
      "GST আছে? GST চালু করুন, GSTIN ও ডিফল্ট রেট দিন",
      "WhatsApp নম্বর লিংক করুন — বট WhatsApp-এও চলবে",
      "স্টক রাখবেন? Dukaan Register → Stock ট্যাবে আইটেম যোগ করুন (বলে/টাইপ/CSV)। নতুন মাল এলে বলুন \"৫০ কিলো চাল এসেছে\"",
      "ভয়েসে বিক্রি করুন — বলুন \"রমেশকে ২ কিলো আটার বিল বানাও\"। বিল রেডি — WhatsApp-এ পাঠান!",
    ],
  },
  pa: {
    title: "ਕੁਇੱਕ ਸੈੱਟਅੱਪ — 2 ਮਿੰਟ",
    sub: "ਇੱਕ ਵਾਰ ਕਰੋ, ਫਿਰ ਬੱਸ ਮੁਨਸ਼ੀ ਨਾਲ ਗੱਲ ਕਰੋ!",
    steps: [
      "Settings ਖੋਲ੍ਹੋ (ਚੈਟ ਵਿੱਚ ⚙ ਆਈਕਨ) — ਦੁਕਾਨ ਦਾ ਨਾਮ ਲਿਖੋ",
      "ਲੋਗੋ ਹੈ? ਅੱਪਲੋਡ ਕਰੋ — PDF ਬਿੱਲ 'ਤੇ ਦਿਸੇਗਾ",
      "ਬਿੱਲ prefix ਅਤੇ ਸ਼ੁਰੂਆਤੀ ਨੰਬਰ ਸੈੱਟ ਕਰੋ (ਜਿਵੇਂ INV-101)",
      "GST ਹੈ? GST ਚਾਲੂ ਕਰੋ, GSTIN ਅਤੇ ਡਿਫਾਲਟ ਰੇਟ ਪਾਓ",
      "WhatsApp ਨੰਬਰ ਲਿੰਕ ਕਰੋ — ਬੋਟ WhatsApp 'ਤੇ ਵੀ ਚੱਲੇਗਾ",
      "ਸਟਾਕ ਰੱਖਣਾ ਹੈ? Dukaan Register → Stock ਟੈਬ ਵਿੱਚ ਚੀਜ਼ਾਂ ਜੋੜੋ (ਬੋਲ ਕੇ/ਟਾਈਪ/CSV)। ਨਵਾਂ ਮਾਲ ਆਵੇ ਤਾਂ ਕਹੋ \"50 ਕਿਲੋ ਚਾਵਲ ਆਏ\"",
      "ਬੋਲ ਕੇ ਵਿਕਰੀ ਕਰੋ — \"ਰਮੇਸ਼ ਨੂੰ 2 ਕਿਲੋ ਆਟੇ ਦਾ ਬਿੱਲ ਬਣਾਓ\"। ਬਿੱਲ ਤਿਆਰ — WhatsApp 'ਤੇ ਭੇਜੋ!",
    ],
  },
  ml: {
    title: "ക്വിക്ക് സെറ്റപ്പ് — 2 മിനിറ്റ്",
    sub: "ഒരിക്കൽ ചെയ്യൂ, പിന്നെ മുൻഷിയോട് സംസാരിക്കൂ!",
    steps: [
      "Settings തുറക്കുക (ചാറ്റിലെ ⚙ ഐക്കൺ) — കടയുടെ പേര് നൽകുക",
      "ലോഗോ ഉണ്ടോ? അപ്‌ലോഡ് ചെയ്യുക — PDF ബില്ലിൽ കാണാം",
      "ബിൽ prefix-ഉം തുടക്ക നമ്പറും സെറ്റ് ചെയ്യുക (ഉദാ. INV-101)",
      "GST ഉണ്ടോ? GST ഓൺ ചെയ്ത് GSTIN-ഉം ഡിഫോൾട്ട് നിരക്കും ചേർക്കുക",
      "WhatsApp നമ്പർ ലിങ്ക് ചെയ്യുക — ബോട്ട് WhatsApp-ലും പ്രവർത്തിക്കും",
      "സ്റ്റോക്ക് വേണോ? Dukaan Register → Stock ടാബിൽ സാധനങ്ങൾ ചേർക്കുക (സംസാരിച്ച്/ടൈപ്പ്/CSV)। പുതിയ സാധനം വന്നാൽ \"50 കിലോ അരി വന്നു\" എന്ന് പറയൂ",
      "വോയ്സിൽ വിൽപ്പന — \"രമേശിന് 2 കിലോ ആട്ടയുടെ ബിൽ ഉണ്ടാക്കൂ\" എന്ന് പറയൂ. ബിൽ റെഡി — WhatsApp-ൽ അയയ്ക്കൂ!",
    ],
  },
};
